import {
  toWSDateString,
  WSCard,
  WSDataItem,
  WSGrid,
  WSInfoBox,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";

import { PayrollRunDetails } from "../../types";

const EMPTY_VALUE = "—";

type Props = {
  payrollRun: PayrollRunDetails;
};

export const PayrollRunDetailsCard: React.FC<Props> = ({ payrollRun }) => {
  const liabilityBreakdown = [
    { label: "Gross amount", amount: payrollRun.grossAmount },
    { label: "Payer taxes", amount: payrollRun.payerTaxes },
    { label: "Benefits", amount: payrollRun.benefits }
  ];

  return (
    <WSCard header={{ label: "Funding amount" }}>
      <WSGrid gutter="L">
        <WSGrid.Item span={{ s: "12", l: "6" }}>
          <WSList gap="S">
            <WSInfoBox>
              <WSText.Paragraph color="gray600" mb="XS" weight="medium">
                Liability amount
              </WSText.Paragraph>
              <WSText.Heading1 color="gray500" weight="book">
                {payrollRun.liabilityAmount === undefined
                  ? "Not available"
                  : formatMoney(payrollRun.liabilityAmount, Currency.USD)}
              </WSText.Heading1>
            </WSInfoBox>

            <WSInfoBox>
              <WSList gap="S">
                {liabilityBreakdown.map(item => (
                  <WSDataItem
                    key={item.label}
                    inline
                    label={item.label}
                    value={formatMoney(item.amount, Currency.USD)}
                  />
                ))}
              </WSList>
            </WSInfoBox>
          </WSList>
        </WSGrid.Item>

        <WSGrid.Item span={{ s: "12", l: "6" }}>
          <WSList gap="XL">
            <WSDataItem
              label="Payroll start date"
              value={toWSDateString(
                payrollRun.payrollStartDate,
                "monthDayYear"
              )}
            />
            <WSDataItem
              label="Payroll finalization date"
              value={
                payrollRun.finalizationDate
                  ? toWSDateString(payrollRun.finalizationDate, "monthDayYear")
                  : EMPTY_VALUE
              }
            />
            <WSDataItem label="Pay period" value={payrollRun.payPeriodRange} />
            <WSDataItem
              label="Pay date"
              value={
                payrollRun.payDate
                  ? toWSDateString(payrollRun.payDate, "monthDayYear")
                  : EMPTY_VALUE
              }
            />
          </WSList>
        </WSGrid.Item>
      </WSGrid>
    </WSCard>
  );
};
